/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  GamoraFoundationNodeArgs,
  GamoraFoundationTaskManager,
} from '@ver.id/libs.internal.gamora';
import { IHoruz } from '../../../horuz.js';

/**
 * Children map
 * @public
 */
export type HoruzProtocolChulakTaskManagerNodeChildrenMap<
  TRoot extends IHoruz,
> = Record<string, never>;

/**
 * Args
 * @public
 */
export type HoruzProtocolChulakTaskManagerNodeArgs<TRoot extends IHoruz> =
  GamoraFoundationNodeArgs<
    HoruzProtocolChulakTaskManagerNodeChildrenMap<TRoot>
  >;

/**
 * HoruzProtocolChulakTaskManagerNode
 * @public
 */
export class HoruzProtocolChulakTaskManagerNode<
  TRoot extends IHoruz,
> extends GamoraFoundationTaskManager<
  HoruzProtocolChulakTaskManagerNodeChildrenMap<TRoot>
> {
  constructor(args: HoruzProtocolChulakTaskManagerNodeArgs<TRoot>) {
    super({
      ...args,
    });
  }
}
